var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"handout-download-link"},[(_vm.handout.attachment)?[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.download()}}},[_vm._v(_vm._s(_vm.handout.label))])]:[_c('a',{attrs:{"target":"_blank","href":`/yph_pdfs/${_vm.handout.pdf}`}},[_vm._v(_vm._s(_vm.handout.label))])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }